<section class="container tridys-page">
  <div class="mt-3">
    <h1 class="mb-1">{{'tridys.listTitle' | translate}}</h1>
    <p style="font-family:'MyFont-Light';">{{'tridys.loadedCount' | translate:{loaded: tridysData.length, total: totalTridys || tridysData.length} }}</p>
  </div>

  <div class="tab-toolbar my-4">
    <div class="tridys-toolbar-actions">
      <button mat-button class="orange-button" (click)="openGenerateTridys()">
        <mat-icon>add</mat-icon>
        {{'tridys.generate' | translate}}
      </button>
    </div>
    <div class="tridys-toolbar-search">
      <mat-form-field class="pt-3 m-2 mb-0 mt-0 search">
        <mat-label>{{'search_title' | translate}}</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="{{'search' | translate}}" #input>
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  @if(!isLoadingTridys && tridysData.length === 0) {
    <div class="p-2 empty-list">{{'tridys.empty_title' | translate}}</div>
  }

  <div class="grid-shell" [class.has-load-more]="hasMoreTridys">
    @if (selectedTridys.length) {
      <div class="selection-toolbar">
        <span>{{selectedTridys.length}} {{'selected' | translate}}</span>
        <button mat-button class="orange-button" (click)="openQrExportDialog()"><mat-icon>download</mat-icon> {{'tridys.qrExport.downloadZip' | translate}}</button>
        @if (canDeleteTridys) {
          <button mat-button class="danger-button" (click)="deleteSelectedTridys()"><mat-icon>delete</mat-icon> {{'delete' | translate}}</button>
        }
      </div>
    }
    <ag-grid-angular
      appFitGridToViewport
      class="tridys-grid"
      [theme]="theme"
      [rowData]="tridysData"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [localeText]="agGridLocaleText"
      [autoSizeStrategy]="autoSizeStrategy"
      [rowSelection]="rowSelection"
      [selectionColumnDef]="selectionColumnDef"
      [rowHeight]="56"
      [headerHeight]="48"
      [quickFilterText]="quickFilterText"
      [pagination]="true"
      [paginationPageSize]="25"
      [paginationPageSizeSelector]="paginationPageSizeSelector"
      (selectionChanged)="onSelectionChanged($event)"
      (rowClicked)="openTridy($event)">
    </ag-grid-angular>
    @if (hasMoreTridys) {
      <div class="load-more-row">
        <button type="button" class="load-more-link" (click)="loadMoreTridys()" [disabled]="isLoadingTridys">
          {{'tridys.loadMore' | translate}}
        </button>
      </div>
    }
  </div>
</section>
